import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/attachments-list.scss';

Component('tr-attachments-list', {
  mixins: [eventListenerMixin],

  properties: {
    canExpand: {
      type: Boolean,
      default: false,
    },

    expanded: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.container = this.querySelector('.attachments-container');
    this.link = this.querySelector('.link-toggle-expand');

    if (this.container.scrollHeight > 380) {
      this.listenTo(this.link, 'click', () => {
        this.link.remove();
        this.expanded = true;
      });
      this.canExpand = true;
    } else if (this.link) this.link.remove();
  },

  disconnected() {
    this.stopListening();
  },
});
